import React from "react";

import { useTheme } from "@mui/material/styles";
import { Card, CardContent, Typography, Box } from "@mui/material";

import WarningAmberIcon from "@mui/icons-material/WarningAmber";

import { SCSLoadingButton } from "app/modules/common/components/Buttons/SCSButtons";

const CardWarningLinkPago = ({
  mensajeWarning,
  handleRender,
  mensajeBoton = "intentar nuevamente",
  detalleMensaje,
}) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        width: "100%",
        minWidth: "100%",
        margin: "auto",
        borderRadius: "16px",
        boxShadow: 3,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center", // Centrar el contenido verticalmente
        alignItems: "center",
        textAlign: "center",

        /*  [theme.breakpoints.up("sm")]: { width: "50%" }, */
        [theme.breakpoints.up("md")]: { width: "50%" },
        [theme.breakpoints.up("lg")]: { width: "100%" },
      }}
    >
      <CardContent
        sx={{
          width: "100%",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Título de Advertencia */}
        <Typography
          variant="h3"
          gutterBottom
          color="warning.main"
          sx={{
            fontSize: "30px",
            padding: "2rem 0",
            margin: "0",
            "@media (max-width: 1360px)": {
              padding: "1rem 0",
              fontSize: "25px",
              fontWeight: "500",
            },
          }}
        >
          Advertencia
        </Typography>

        {/* Icono de Advertencia con el círculo y elementos decorativos */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#FFF59D", // Fondo de color amarillo claro
            borderRadius: "50%",
            width: 100,
            height: 100,
            position: "relative",
            mb: 3,

            "@media (max-width: 1360px)": {
              width: 70,
              height: 70,
            },
          }}
        >
          <WarningAmberIcon
            sx={{
              fontSize: 48,
              color: "#FFB300",
              "@media (max-width: 1360px)": {
                fontSize: 40,
              },
            }}
          />
          {/* Elementos decorativos (pequeños círculos alrededor) */}
          <Box
            sx={{
              position: "absolute",
              top: -10,
              left: 20,
              width: 5,
              height: 5,
              bgcolor: "#FFD54F",
              borderRadius: "50%",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              top: 20,
              right: -10,
              width: 5,
              height: 5,
              bgcolor: "#FFCA28",
              borderRadius: "50%",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              bottom: -10,
              left: 10,
              width: 5,
              height: 5,
              bgcolor: "#FFC107",
              borderRadius: "50%",
            }}
          />
        </Box>

        {/* Mensaje Principal */}
        <Typography
          variant="h4"
          gutterBottom
          color="warning.success"
          sx={{ fontSize: "18px" }}
        >
          {mensajeWarning}
        </Typography>

        {/* Descripción de la Advertencia */}
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 3, px: 2 }}
        >
          {detalleMensaje}
        </Typography>

        {/* Botón para continuar */}
        <SCSLoadingButton
          titulo={mensajeBoton}
          size={50}
          color="warning"
          onClick={handleRender}
        />
      </CardContent>
    </Card>
  );
};

export default CardWarningLinkPago;
